import { TableCell, TableRow, Typography } from "@mui/material";
import { TWeightDocument } from "../../../../content/types";
import { FC } from "react";

type Props = {
  document: TWeightDocument;
};

export const DocumentRow: FC<Props> = ({ document }) => {
  return (
    <TableRow>
      <TableCell component="th" scope="row">
        {document.title}
      </TableCell>
      <TableCell>
        <Typography noWrap>Wiege: {document.weight} kg</Typography>
        <Typography noWrap>
          Gemessen am: {new Date(document.measurementDate).toLocaleDateString()}
        </Typography>
        <Typography noWrap>
          Hochgeladen am:{new Date(document.createdOn).toLocaleDateString()}
        </Typography>
      </TableCell>
    </TableRow>
  );
};
